var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":true}},[_c('div',{staticClass:"d-flex flex-column align-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}}),_c('span',{staticClass:"pt-2"},[_vm._v(_vm._s(_vm.msg))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }